import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-16 bg-brand-sage/10" data-id="element-39">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-40">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-white p-8 md:p-12 rounded-2xl shadow-xl border border-brand-sage/20" data-id="element-41">
          <div className="w-20 h-20 bg-brand-sage/10 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-42">
            <ShieldCheck className="w-10 h-10 text-brand-sage" data-id="element-43" />
          </div>

          <h2 className="font-serif text-2xl md:text-3xl font-bold text-brand-dark mb-4" data-id="element-44">
            Garantía de "Cero Riesgo" por 30 Días
          </h2>

          <p className="font-sans text-brand-warm-gray mb-6 leading-relaxed" data-id="element-45">
            Estoy tan segura de que este protocolo cambiará cómo te sientes, que
            asumo todo el riesgo. Entra, prueba las recetas, aplica los trucos
            de sueño y sigue el plan. Si en 30 días no sientes que has
            recuperado energía y claridad, escríbeme y te devuelvo el 100% de tu
            dinero. Sin preguntas.
          </p>

          <div className="inline-block px-6 py-2 bg-brand-cream rounded-full border border-brand-sage/30" data-id="element-46">
            <span className="font-bold text-brand-sage text-sm uppercase tracking-wide" data-id="element-47">
              100% Satisfacción Garantizada
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}